import * as React from 'react';

const SvgEnter = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 10, viewBox: "0 0 12 10", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.68271 9.27699L0.411399 6.04545L3.68271 2.81392V9.27699ZM2.64862 6.78125V5.30966H11.6671V6.78125H2.64862ZM10.2402 6.78125V0.318182H11.6969V6.78125H10.2402Z", fill: "currentColor" }));

export { SvgEnter as default };
//# sourceMappingURL=Enter.svg.js.map
